/* Nibby: footer menus are <details open> (readable without JS). On mobile they start closed
   and toggle under their heading; on tablet/desktop they are kept open and can't be closed. */
(() => {
  const mobile = window.matchMedia('(max-width: 749px)');

  const sync = () => {
    document.querySelectorAll('[data-nibby-footer-acc]').forEach((menu) => {
      menu.open = !mobile.matches;
      const summary = menu.querySelector('summary');
      if (mobile.matches) summary.removeAttribute('tabindex');
      else summary.setAttribute('tabindex', '-1');
    });
  };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('[data-nibby-footer-acc] > summary');
    if (summary && !mobile.matches) event.preventDefault();
  });

  sync();
  mobile.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
